import EventEmitterEx from './EventEmitterEx'

export default class EventEmitterExResident extends EventEmitterEx {
}
